module.exports = __webpack_public_path__ + "img/no-data.9a2c1009.png";